(function () {
  // expects window.quickAddDrawerSwiper (from quick-add-drawer-product-swiper.js)
  // expects window.postAddToCart (from variant.js)

  const productDrawer = {
    section: null,
    optionInputs: null,
    optionGroups: null,
    variantSelectElement: null,
    addToCartButton: null,
    selectedOptionsString: null,
    optionsDivider: ' / ',
    isPDP: false,
    ifdisplayedProductClicked: false,
    productImageSwiper: null,

    renderDrawerModal(
      section,
      productHTML,
      isPDP,
      ifdisplayedProductClicked,
      productClickedInPdp,
      variantId = null
    ) {
      this.section = section;
      if (productHTML == null) {
        this.section.innerHTML = 'Product details are unavailable, please try again.';
        return;
      }

      this.isPDP = window.location.pathname.indexOf('/products/') !== -1;
      this.ifdisplayedProductClicked = !!ifdisplayedProductClicked;
      this.targetVariantId = variantId; // Store the target variant ID
      this.section.innerHTML = productHTML;

      // DEBUG: Log product object to console
      const productJsonElement = this.section.querySelector('#product-json-data');
      if (productJsonElement) {
        try {
          window.pdpData = JSON.parse(productJsonElement.textContent);
          console.log('product===>', window.pdpData);
        } catch (e) {
          console.log('product===>', productJsonElement.textContent);
        }
      }

      this.initializeElements();
      this.initializeImageCarousels();
      this.addEventHandlers();
      this.updateSwatchAvailability();
      this.updateImageToColorSwatch(this.section);

      // Set specific variant if provided (backup - Shopify should have pre-selected it)
      if (this.targetVariantId) {
        // Increased delay to ensure DOM is fully ready
        setTimeout(() => {
          const currentSelectedVariant = this.variantSelectElement?.value;
          if (currentSelectedVariant !== this.targetVariantId) {
            this.setVariantById(this.targetVariantId);
          }

          if (this.targetVariantId) {
            this.updatePdpLinkWithVariant(this.targetVariantId);
          }
        }, 200);
      }

      if (this.isPDP) this.addWindowEventListeners();
    },

    initializeElements() {
      this.optionInputs = this.section.querySelectorAll('.js-quick-add-product-option-group-value');
      this.optionGroups = this.section.querySelectorAll('.js-quick-add-product-options-group');
      this.variantSelectElement = this.section.querySelector(
        '.js-quick-add-product-variant-select-element'
      );
      this.addToCartButton = this.section.querySelector('.js-quick-buy-add-to-bag');
      this.selectedOptionsString =
        this.variantSelectElement?.querySelector('option:checked')?.dataset?.title || null;
    },

    // Color swatches are simple flex (no swiper)
    initializeColorSwatchCarousels() {
      /* no-op */
    },

    initializeImageCarousels() {
      const swiperContainer = document.querySelector('.js-quick-add-product-swiper-container');
      if (!swiperContainer) {
        if (this.productImageSwiper) {
          this.productImageSwiper.destroy(true, true);
          this.productImageSwiper = null;
        }
        return;
      }
      if (this.productImageSwiper) this.productImageSwiper.destroy(true, true);

      this.productImageSwiper = window.quickAddDrawerSwiper(
        '.js-quick-add-product-swiper-container',
        'auto', // slides are 300px with CSS; use auto to peek next
        4, // 4px gap
        null,
        null,
        '.js-product-drawer-swiper-scrollbar'
      );
    },

    addEventHandlers() {
      if (!this.section) return;

      this.optionInputs.forEach((option) => {
        option.addEventListener('change', () => {
          this.handleVariantSelection();
          this.updateSwatchAvailability();
          this.updateVariantPrices();
        });
      });

      // Add color swatch click handler for both Type 1 and Type 2 products
      this.section.addEventListener('change', (e) => {
        if (e.target.classList.contains('qd-swatch-input')) {
          const swatchLabel = e.target.closest('.qd-swatch-label[data-swatch-variant-id]');
          if (swatchLabel) {
            // Type 2 products: Update PDP link with variant ID
            if (swatchLabel.dataset.swatchVariantId) {
              this.updatePdpLinkWithVariant(swatchLabel.dataset.swatchVariantId);
            }
            // Type 1 products: Update PDP link with new product handle
            else if (swatchLabel.dataset.quickViewHandle) {
              this.updatePdpLinkWithProduct(swatchLabel.dataset.quickViewHandle);
            }
          }
        }
      });

      // Note: Color swatch handling is now done via delegated event listeners
      // in the size retention logic below

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }
    },

    addWindowEventListeners() {
      window.addEventListener('pdpVariantChange', () => {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) this.setVariantOptionsById(variantId);
      });
    },

    setVariantOptionsById(variantId) {
      const matchingOption = this.variantSelectElement?.querySelector(
        `option[value="${variantId}"]`
      );
      if (matchingOption) {
        this.variantSelectElement.value = variantId;
        this.selectedOptionsString = matchingOption.dataset.title;
        this.updateSelectedOptionClasses(this.selectedOptionsString);
      } else {
        const s = this.variantSelectElement?.querySelector('option:checked')?.dataset?.title;
        if (s) this.updateSelectedOptionClasses(s);
      }
    },

    setVariantById(variantId) {
      const matchingOption = this.variantSelectElement?.querySelector(
        `option[value="${variantId}"]`
      );

      if (matchingOption) {
        this.variantSelectElement.value = variantId;
        this.selectedOptionsString = matchingOption.dataset.title;

        // Update the visual option classes first
        this.updateSelectedOptionClasses(this.selectedOptionsString);

        // Update swatch availability and prices
        this.updateSwatchAvailability();
        this.updateVariantPrices();

        // Update add to cart button availability state
        this.updateAddToCartButtonState(matchingOption);
      }
    },

    updateSelectedOptionClasses(selectedOptionsString) {
      const selectedOptions = selectedOptionsString.split(this.optionsDivider);

      this.optionGroups.forEach((group, idx) => {
        const opts = group.querySelectorAll('.js-quick-add-product-option-group-value');
        const targetValue = selectedOptions[idx];

        opts.forEach((input) => {
          // Compare both escaped and unescaped values
          const inputValue = input.value;
          const inputValueUnescaped = inputValue
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');

          if (inputValue === targetValue || inputValueUnescaped === targetValue) {
            group.querySelector('.js-quick-add-product-option-value').innerHTML =
              inputValueUnescaped;
            input.removeAttribute('disabled');
            input.checked = true;
          } else {
            // Uncheck other options in the same group
            input.checked = false;
          }
        });
      });
    },

    updateVariantPrices() {
      const price = this.variantSelectElement
        ?.querySelector('option:checked')
        ?.getAttribute('price');
      const compareAtPrice = this.variantSelectElement
        ?.querySelector('option:checked')
        ?.getAttribute('compare_at_price');

      const priceEls = this.section.querySelectorAll('.js-quick-add-product-variant-price');
      const compareEls = this.section.querySelectorAll(
        '.js-quick-add-product-variant-compare-price'
      );

      compareEls.forEach((el) => {
        el.innerHTML = compareAtPrice || '';
      });
      priceEls.forEach((el) => {
        el.innerHTML = price || '';
      });
    },

    updateAddToCartButtonState(variantOption) {
      if (!this.addToCartButton || !variantOption) return;

      const isDisabled = variantOption.disabled;

      if (isDisabled) {
        // Variant is sold out
        this.addToCartButton.classList.add('is-disabled');
        this.addToCartButton.disabled = true;

        // Clear all existing content and add sold out text
        this.addToCartButton.innerHTML =
          '<span class="text" style="opacity:.7;cursor:not-allowed;">SOLD OUT</span>';
      } else {
        // Variant is available
        this.addToCartButton.classList.remove('is-disabled');
        this.addToCartButton.disabled = false;

        // Restore the "ADD TO CART" structure with text and loader
        this.addToCartButton.innerHTML = `
          <span class="text quick-buy-cta-text">ADD TO CART</span>
          <span class="loader quick-buy-cta-loader sr-only" aria-hidden="true"></span>
        `;
      }

      console.log('Add to cart button state updated. Disabled:', isDisabled);
    },

    updateSwatchAvailability() {
      if (!this.selectedOptionsString) return;
      this.optionGroups.forEach((group, groupIndex) => {
        const options = group.querySelectorAll('.js-quick-add-product-option-group-value');
        options.forEach((input) => {
          const selectedOptions = this.selectedOptionsString.split(this.optionsDivider);
          selectedOptions[groupIndex] = input.value;
          const selector = selectedOptions.join(this.optionsDivider);
          // Escape quotes and other special characters for CSS selector
          const escapedSelector = selector.replace(/"/g, '\\"').replace(/'/g, "\\'");
          const opt = this.variantSelectElement.querySelector(`[data-title="${escapedSelector}"]`);
          input.toggleAttribute('disabled', !!opt?.disabled);
        });
      });
    },

    handleVariantSelection() {
      const selected = [];
      this.optionGroups.forEach((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) selected.push(checked.value);
        group.querySelector('.js-quick-add-product-option-value').innerHTML = checked
          ? checked.value
          : '';
      });

      const selectedOptionsString = selected.join(this.optionsDivider);
      this.selectedOptionsString = selectedOptionsString;

      // Escape quotes and other special characters for CSS selector
      const escapedSelectedOptionsString = selectedOptionsString
        .replace(/"/g, '\\"')
        .replace(/'/g, "\\'");
      const matchingOption = this.variantSelectElement.querySelector(
        `[data-title="${escapedSelectedOptionsString}"]`
      );
      if (matchingOption) {
        this.variantSelectElement.value = matchingOption.value;
        this.variantSelectElement.dispatchEvent(new Event('change'));

        // Update add to cart button state based on availability
        this.updateAddToCartButtonState(matchingOption);
      }
    },

    updateImageToColorSwatch(root) {
      root.querySelectorAll('.js-quick-add-product-option-group-value').forEach((input) => {
        input.addEventListener('change', (e) => {
          const selectedColor = e.target.getAttribute('data-color');
          if (!selectedColor || !this.productImageSwiper) return;

          // For cross-links (different products), we don't need to switch images
          // as each product has its own set of images
          if (e.target.closest('[data-quick-view-handle]')) {
            return;
          }

          // For regular variant selection, filter media based on selected variant
          this.filterMediaByVariant(root, selectedColor);
        });
      });
    },

    filterMediaByVariant(root, selectedColor) {
      const mediaSlides = root.querySelectorAll('.product-drawer-swiper-item');

      mediaSlides.forEach((slide) => {
        const mediaElement = slide.querySelector('img, video, model-viewer');
        if (!mediaElement) return;

        // Check if this media should be shown for the selected color
        const altText = mediaElement.getAttribute('alt') || '';
        const shouldShow = this.shouldShowMediaForColor(altText, selectedColor);

        if (shouldShow) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });

      // Update swiper after filtering
      if (this.productImageSwiper) {
        this.productImageSwiper.update();
      }
    },

    shouldShowMediaForColor(altText, selectedColor) {
      // If no # in alt text, show all media
      if (!altText.includes('#')) return true;

      // Parse the alt text format: "Product Image#Color_Red"
      const parts = altText.split('#');
      if (parts.length < 2) return true;

      const colorPart = parts[1].toLowerCase();
      const selectedColorLower = selectedColor.toLowerCase();

      // Check if the media matches the selected color
      return colorPart.includes(selectedColorLower);
    },

    toggleAddToCartButtonState(isAdding) {
      this.addToCartButton?.classList.toggle('is-adding', isAdding);
      const text = this.addToCartButton?.querySelector('.quick-buy-cta-text');
      const loader = this.addToCartButton?.querySelector('.quick-buy-cta-loader');
      if (text) text.classList.toggle('sr-only', isAdding);
      if (loader) loader.classList.toggle('sr-only', !isAdding);
    },

    async addToCart() {
      let finalVariantId = null;

      // Check if this is a product with variants
      if (this.variantSelectElement && this.optionGroups.length > 0) {
        // Product has variants - use existing logic
        const selected = [];
        this.optionGroups.forEach((g) => {
          const c = g.querySelector('input:checked');
          if (c) {
            // Unescape the input value to match variant data
            const unescapedValue = c.value
              .replace(/&quot;/g, '"')
              .replace(/&amp;/g, '&')
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>');
            selected.push(unescapedValue);
          }
        });
        const key = selected.join(this.optionsDivider);

        // Sync hidden select to exact variant
        finalVariantId = this.variantSelectElement?.value;

        // Escape quotes and other special characters for CSS selector
        const escapedKey = key.replace(/"/g, '\\"').replace(/'/g, "\\'");
        const opt = this.variantSelectElement?.querySelector(`[data-title="${escapedKey}"]`);
        if (opt) {
          this.variantSelectElement.value = opt.value;
          finalVariantId = opt.value;
          this.variantSelectElement.dispatchEvent(new Event('change'));
        }
      } else {
        // Product has no variants - use the default variant ID
        // Get the product ID from the wrapper element or current product
        const wrapperElement = this.section?.querySelector('.qd-wrap');
        const productId = wrapperElement?.dataset?.productId || window.currentProductId;
        if (productId && window.pdpData) {
          const product = window.pdpData.find((p) => p.id == productId);
          if (product && product.variants && product.variants.length > 0) {
            finalVariantId = product.variants[0].id; // Use first variant
          }
        }
      }

      if (!finalVariantId) {
        console.error('No variant ID found for add to cart');
        return;
      }

      this.toggleAddToCartButtonState(true);

      try {
        await window.postAddToCart(finalVariantId, null, {
          triggerElement: this.section,
          skipCartDrawer: true, // We'll handle drawer closing separately
        });

        // Close the quick drawer
        if (window.QuickBuy?.hide) {
          window.QuickBuy.hide();
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        // Show error to user
        alert('Sorry, there was an error adding this item to your cart. Please try again.');
      } finally {
        this.toggleAddToCartButtonState(false);
      }
    },

    updatePdpLinkWithVariant(variantId) {
      const pdpLink = this.section.querySelector('.qd-pdp-link a');
      if (pdpLink && variantId) {
        const currentUrl = pdpLink.getAttribute('href');
        const baseUrl = currentUrl.split('?')[0]; // Remove any existing query params
        const newUrl = `${baseUrl}?variant=${variantId}`;
        pdpLink.setAttribute('href', newUrl);
      }
    },

    updatePdpLinkWithProduct(productHandle) {
      const pdpLink = this.section.querySelector('.qd-pdp-link a');
      if (pdpLink && productHandle) {
        const newUrl = `/products/${productHandle}`;
        pdpLink.setAttribute('href', newUrl);
      }
    },
  };

  // expose for quick-drawer.js (call window.renderDrawerModal(...))
  window.renderDrawerModal = productDrawer.renderDrawerModal.bind(productDrawer);

  // Size Retention Logic for Quick Drawer
  function initializeQuickDrawerSizeRetention() {
    // Function to get current variant options from quick drawer
    function getCurrentVariantOptions() {
      const quickDrawer = document.querySelector('.js-quick-add-product-drawer');
      if (!quickDrawer) return null;

      const variantSelect = quickDrawer.querySelector(
        '.js-quick-add-product-variant-select-element'
      );
      if (!variantSelect) return null;

      const selectedOption = variantSelect.querySelector('option:checked');
      if (!selectedOption) return null;

      const title = selectedOption.getAttribute('data-title');
      if (!title) return null;

      return title.split(' / ');
    }

    // Function to find variant ID in target product based on matching options
    function findMatchingVariantId(targetProductId, currentOptions) {
      if (!currentOptions?.length || !window.pdpData) return null;

      // Find the target product by ID
      const targetProduct = window.pdpData.find((product) => product.id == targetProductId);
      if (!targetProduct?.variants) return null;

      // Get the number of options to match (excluding the first option which is usually color)
      const [, ...optionsToMatch] = currentOptions;

      return (
        targetProduct.variants.find((variant) =>
          optionsToMatch.every(
            (opt, i) => variant.options[i + 1] === opt // skip color at index 0
          )
        )?.id || null
      );
    }

    // Function to handle color swatch click in quick drawer
    function handleQuickDrawerColorSwatchClick(swatch) {
      // Get current options from quick drawer
      const currentOptions = getCurrentVariantOptions();

      // Get the product handle from the swatch
      const handle = swatch.getAttribute('data-quick-view-handle');
      if (!handle) {
        console.log('No handle found on swatch');
        return;
      }

      // If no current options (product has no variants), just switch to the new product
      if (!currentOptions?.length) {
        console.log(
          'No current options found in quick drawer, switching to new product without variant matching'
        );
        if (window.QuickBuy && window.QuickBuy.trigger) {
          window.QuickBuy.trigger(handle);
        }
        return;
      }

      // Extract product ID from handle (assuming handle format like "10mm-lever-belt-black")
      // We need to find the product ID from the handle
      const targetProduct = window.pdpData?.find((product) => product.handle === handle);
      if (!targetProduct) {
        return;
      }

      const targetProductId = targetProduct.id;

      // Find matching variant ID in target product
      const targetVariantId = findMatchingVariantId(targetProductId, currentOptions);

      if (!targetVariantId) {
        // Still trigger the product switch without variant
        if (window.QuickBuy && window.QuickBuy.trigger) {
          window.QuickBuy.trigger(handle);
        }
        return;
      }

      // Trigger quick drawer with variant parameter
      if (window.QuickBuy && window.QuickBuy.trigger) {
        window.QuickBuy.trigger(`${handle}?variant=${targetVariantId}`);
      }
    }

    // Add delegated click listener for quick drawer color swatches
    document.addEventListener('click', (e) => {
      // Check if click is on a color swatch in quick drawer
      const swatch = e.target.closest('.qd-swatch-label[data-quick-view-handle]');
      if (swatch) {
        e.preventDefault();
        e.stopPropagation();
        handleQuickDrawerColorSwatchClick(swatch);
      }
    });
  }

  // Initialize size retention when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeQuickDrawerSizeRetention);
  } else {
    initializeQuickDrawerSizeRetention();
  }
})();
